import { ReactNode, useContext } from "react";
import { WidgetBoxContext } from "./widget-box";
import { Box } from "@chakra-ui/react";

type WidgetBoxActionsProps = {
    children: ReactNode;
};

export const WidgetBoxActions = ({ children }: WidgetBoxActionsProps) => {
    const insideWidgetBox = useContext(WidgetBoxContext);

    if (!insideWidgetBox) {
        throw new Error("WidgetBoxActions must be used within a WidgetBox");
    }

    return <Box>{children}</Box>;
};
